import { Download, RefreshCw, Settings2, ShieldCheck, TextCursorInput } from "lucide-react";
import { ENGINE_OPTIONS } from "../features/svg-jobs/status";
import { useJobStore } from "../store/useJobStore";

export function SettingsPage() {
  const { engine, optimize, autoDownload, wrapEditor, realtimeState, setEngine, setOptimize, setAutoDownload, setWrapEditor } = useJobStore();

  return (
    <div className="page-container settings-page" data-ui-capture="settings-page">
      <header className="page-header"><div><span className="kicker">PREFERENCES</span><h1>工作台设置</h1><p>这些偏好保存在当前浏览器，不包含服务端密钥。</p></div></header>

      <section className="panel settings-card">
        <div className="section-heading border-bottom"><div><span className="settings-icon"><Settings2 size={18} /></span><h2>默认绘图配置</h2><p>创建新任务时使用的默认选项。</p></div></div>
        <div className="settings-list">
          <label className="setting-row"><div><strong>默认引擎</strong><span>仍可在每个任务中单独修改。</span></div><select value={engine} onChange={(event) => setEngine(event.target.value as typeof engine)}>{ENGINE_OPTIONS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}</select></label>
          <label className="setting-row"><div><strong>启用 SVG 优化</strong><span>减少体积，同时保留 viewBox、ID、defs 和 marker。</span></div><input type="checkbox" className="native-switch" checked={optimize} onChange={(event) => setOptimize(event.target.checked)} /></label>
        </div>
      </section>

      <section className="panel settings-card">
        <div className="section-heading border-bottom"><div><span className="settings-icon"><Download size={18} /></span><h2>交付与编辑</h2><p>控制任务完成后的行为和代码编辑体验。</p></div></div>
        <div className="settings-list">
          <label className="setting-row"><div><strong>完成后自动下载</strong><span>单输出下载 SVG，多输出下载 ZIP；每个任务每次会话仅触发一次。</span></div><input type="checkbox" className="native-switch" checked={autoDownload} onChange={(event) => setAutoDownload(event.target.checked)} /></label>
          <label className="setting-row"><div><strong>代码编辑器自动换行</strong><span>长行仅改变显示，不修改源码内容。</span></div><input type="checkbox" className="native-switch" checked={wrapEditor} onChange={(event) => setWrapEditor(event.target.checked)} /></label>
        </div>
      </section>

      <section className="settings-info-grid">
        <article className="panel info-card"><ShieldCheck size={20} /><div><strong>私有存储</strong><span>源码和结果位于私有 Supabase Storage，下载链接有效期为 5 分钟。</span></div></article>
        <article className="panel info-card"><RefreshCw size={20} /><div><strong>状态同步</strong><span>当前：{realtimeState === "connected" ? "Realtime 已连接" : realtimeState === "fallback" ? "使用定时刷新兜底" : "正在连接 Realtime"}。</span></div></article>
        <article className="panel info-card"><TextCursorInput size={20} /><div><strong>草稿保存</strong><span>引擎、代码、文件名和筛选条件会保存在本机浏览器。</span></div></article>
      </section>
    </div>
  );
}
